
import { Component, Vue } from "vue-property-decorator";
import Telefonos from "@/components/Web/Telefonos.vue";

@Component({
  components: {
    Telefonos
  },
  meta: {
    // sets document title
    title: "Oficinas y Teléfonos - Municipalidad de Maipú",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí las Oficinas y Teléfonos disponibles para ti."
      },
      keywords: { name: "keywords", content: "Maipú" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class TelefonosView extends Vue {
  private mounted() {
    document.title = "Oficinas y Teléfonos - Municipalidad de Maipú";
  }
}
